import {RefrigeratorUnit} from '../models/refrigerator/refrigeratorUnit.model';
import {RefrigeratorComponent} from '../models/refrigerator/refrigeratorComponent.model';
import {JobRefrigeratorUnit} from '../models/refrigerator/jobRefrigeratorUnit.model';

export namespace Refrigerator {
  export class GetRefrigeratorUnits {
    static readonly type = '[Refrigerator api] Get Refrigerator Units';

    constructor(public force: boolean = false) {
    }
  }

  export class GetRefrigeratorUnit {
    static readonly type = '[Refrigerator api] Get Refrigerator Unit';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateRefrigeratorUnit {
    static readonly type = '[Refrigerator api] Create Refrigerator Unit';

    constructor(public unit: RefrigeratorUnit) {
    }
  }

  export class UpdateRefrigeratorUnit {
    static readonly type = '[Refrigerator api] Update Refrigerator Unit';

    constructor(public unit: RefrigeratorUnit) {
    }
  }

  export class DeleteRefrigeratorUnit {
    static readonly type = '[Refrigerator api] Delete Refrigerator Unit';

    constructor(public unit: RefrigeratorUnit) {
    }
  }

  export class GetRefrigeratorComponents {
    static readonly type = '[Refrigerator api] Get Refrigerator Components';

    constructor(public force: boolean = false) {
    }
  }

  export class GetRefrigeratorComponent {
    static readonly type = '[Refrigerator api] Get Refrigerator Component';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateRefrigeratorComponent {
    static readonly type = '[Refrigerator api] Create Refrigerator Component';

    constructor(public component: RefrigeratorComponent) {
    }
  }

  export class UpdateRefrigeratorComponent {
    static readonly type = '[Refrigerator api] Update Refrigerator Component';

    constructor(public component: RefrigeratorComponent) {
    }
  }

  export class DeleteRefrigeratorComponent {
    static readonly type = '[Refrigerator api] Delete Refrigerator Component';

    constructor(public component: RefrigeratorComponent) {
    }
  }

  export class GetJobRefrigeratorUnits {
    static readonly type = '[Refrigerator api] Get Job Refrigerator Units';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class GetJobRefrigeratorUnit {
    static readonly type = '[Refrigerator api] Get Job Refrigerator Unit';

    constructor(public id: string, public unitId: string, public force: boolean = false) {
    }
  }

  export class UpdateJobRefrigeratorUnits {
    static readonly type = '[Refrigerator api] Update Job Refrigerator Units';

    constructor(public id: string, public jobUnits: JobRefrigeratorUnit[], public designConditions: string, public offer: string) {
    }
  }

  export class AssignRefrigeratorSerialNumbers {
    static readonly type = '[Refrigerator api] Assign Refrigerator Serial Numbers';

    constructor(public id: string) {
    }
  }

  export class ResetQuoteUnitsPricing {
    static readonly type = '[Refrigerator api] Reset Quote Units Pricing';

    constructor(public id: string) {
    }
  }
}
